import React from 'react';
import '../../../css/titleprogressbar.scss';
import { useEffect } from "react";
import { ProgressBar, Button } from 'react-bootstrap';
import { useState } from 'react';

const TitleProgressBar = ({ text, percentage, totalQuestion }) => {
    const [questionNumber, setQuestionNumber] = useState(1);

    useEffect(() => {
        setQuestionNumber(Math.round(percentage/100 * totalQuestion));
    }, [percentage]);

    return (
        <div>  
            {          
            (text) && 
                (<p className='text-title'>{text}</p>)
            }
            <div className="progress-bar-class">
                <ProgressBar now={percentage} />
            </div>
            <p className='text-question'>Question {questionNumber}/{totalQuestion}</p>
        </div>      
    );
};

export default TitleProgressBar;
